import React, {useState, useRef, useEffect} from 'react';
import styles from "../../assets/stylesheets/sass/Popup.module.scss";
import close_icon from "../../assets/icons/close_icon_white.svg";
import Lottie from 'react-lottie';
import loading_animation from "../../assets/animations/loading_success_error.json";

export default function LoadingStatus({message, loadingIcon, status, onClose}){

  const [showContainer, setshowContainer] = useState(true);
  const [enableContainer, setenableContainer] = useState(true);

  const animationRef = useRef(null);

  const handleClickCloseContainer = () =>{
    setshowContainer(false);

    setTimeout(function(){
      setenableContainer(false)
      setshowContainer(false);
      onClose(true)
    }, 400)
  }

  useEffect(()=>{
    if(animationRef.current && status === "loading"){
      const { anim } = animationRef.current;
      anim.playSegments([1, 119], true);
    }
  }, [])

  useEffect(()=>{
    let cancel = false;
    setshowContainer(true);
    setenableContainer(true);
    if(animationRef.current){
    const { anim } = animationRef.current;

      if(anim){
        if(status === "success"){
          //success
          setenableContainer(true);
          anim.speed = 4;
          anim.loop = false;
          anim.playSegments([238, 397], true);

          setTimeout(function(){
            if (cancel) return;
            setshowContainer(false);

            setTimeout(function(){
              if (cancel) return;
              setenableContainer(true);
            }, 1000)
          }, 3000)
        }
        else if(status === "failed"){
          //failed
          anim.speed = 4;
          anim.loop = false
          anim.playSegments([690, 816], true);
        }
        else if(status === "loading"){
          //loading        
          setenableContainer(true);
          anim.playSegments([0, 119], true);
        }
      }
    }

    return () => { 
        cancel = true;
    }
  }, [status, animationRef])

  const defaultOptions = {
    loop: true,
    autoplay: false,
    animationData: loading_animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <>
    {(enableContainer && status !== "") &&
    <div className={showContainer ? styles.loading_container : styles.loading_container_animateOut}>
        {loadingIcon && <div className={styles.loading_lottie}><Lottie ref={animationRef} options={defaultOptions} width={25} height={25}/></div>}
        <p className={styles.loading_message}>{message}</p>
        <button className={styles.loading_button_close} onClick={()=>{handleClickCloseContainer()}}>
            <img src={close_icon} alt="icon"/>
        </button>
    </div>
    }
    </>
  )
}